import React from 'react';
import enhance from './enhance';
import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  Area,
} from 'recharts';
import styles from './styles.module.scss';

export const CompetitionChart = ({
  data,
  showCompetition,
  showOwn,
  resetFilters,
  toggleOwnLine,
  toggleCompetitionArea,
  selectedTemplateStyle,
  competitionStyle,
  clearFiltersLabel,
  selectedTemplatesLabel,
  competitorDistributionLabel,
}) => (
  <div className={styles.competitionChart}>
    <ResponsiveContainer width="100%" height="85%">
      <ComposedChart
        width={600}
        height={300}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis
          dataKey="priceBucketLabel"
          padding={{ left: -55 }}
          tick={{ fontSize: 12, dy: 10 }}
          allowDecimals={false}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 10 }}
          allowDecimals={false}
          domain={[0, 100]}
          label={{ value: 'Pct', position: 'insideTopLeft' }}
        />
        <Tooltip formatter={value => `${value}%`} />
        {showCompetition && (
          <Area
            type="monotone"
            dataKey="competition"
            fill="#d3d3e0"
            stroke="#d3d3e0"
            animationDuration={1000}
            dot={{ strokeWidth: 2, stroke: 'white', fill: '#d3d3e0', r: 6 }}
          />
        )}
        {showOwn && (
          <Line
            type="monotone"
            dataKey="own"
            connectNulls={true}
            animationDuration={1000}
            dot={{
              strokeWidth: 2,
              stroke: 'white',
              fill: 'blue',
              r: 6,
            }}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
    <div className={styles.filterContainer}>
      <div className={styles.filterSection}>
        <button onClick={toggleOwnLine} className={selectedTemplateStyle}>
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{ fill: '#0064d9', strokeWidth: 3, stroke: '#0064d9' }}
            />
          </svg>
          {selectedTemplatesLabel}
        </button>
        <button onClick={toggleCompetitionArea} className={competitionStyle}>
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{ fill: '#e6e6f0', strokeWidth: 3, stroke: '#e6e6f0' }}
            />
          </svg>
          {competitorDistributionLabel}
        </button>
      </div>
      <span className={styles.clearFilters} onClick={resetFilters}>
        {clearFiltersLabel}
      </span>
    </div>
  </div>
);

export default enhance(CompetitionChart);
